import React, { Component } from 'react';
import styled from 'styled-components';
import Helmet from 'react-helmet';
import axios from 'axios';

import StartButton from '../components/StartButton';

const partners1 = [
  { src: '/images/redesign/ladbrokes.png' },
  { src: '/images/redesign/newscorp.png' },
  { src: '/images/redesign/goget.png' },
  { src: '/images/redesign/tnt.png' },
  { src: '/images/redesign/toll.png' },
];

const partners2 = [
  { src: '/images/redesign/mmg.png' },
  { src: '/images/redesign/rapyd.png' },
  { src: '/images/redesign/wechatpay.png' },
  { src: '/images/redesign/alipay.png' },
  { src: '/images/redesign/sodaking.png' },
  { src: '/images/redesign/newspower.png' },
];

const partners3 = [
  { src: '/images/redesign/bitcoin.png' },
  { src: '/images/redesign/btc.png' },
  { src: '/images/redesign/cointree.png' },
  { src: '/images/redesign/coinjar.png' },
  { src: '/images/redesign/coinspot.png' },
  { src: '/images/redesign/coinloft.png' },
];

export default class SignupWelcome extends Component {
  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
  }

  onSubmit() {
    const params = decodeURI(window.location.search).replace('?', '');
    window.location.replace(`/signup-overview?${params}`);
  }

  render() {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100vh' }}>
        <Helmet
					title="Welcome"
					meta={[
						{ charset: 'utf-8' },
						{ name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no' },
						{ name: 'description', content: 'Welcome' },
					]}
					link={[
						{ href: 'https://fonts.googleapis.com/css?family=Roboto+Slab|Karla', rel: 'stylesheet' },
					]}
				/>
        <div>
          <CenteredSection>
            <div>
              <Image
                style={{ width: 550 }}
                src="/images/redesign/blueshyft.png"
              />
            </div>
          </CenteredSection>
          <CenteredSection>
            <div style={{ margin: 20 }}>
              <Text>Transforming retailers for the digital age</Text>
            </div>
          </CenteredSection>
          <CenteredSection>
            <div style={{ width: 700 }}>
              <StartButton text="START" onSubmit={this.onSubmit} />
            </div>
          </CenteredSection>
          <CenteredSection>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              { partners1.map(partner => (
                <ImageContainer>
                  <Image src={partner.src} />
                </ImageContainer>
              ))}
            </div>
          </CenteredSection>
          <CenteredSection>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              { partners2.map(partner => (
                <ImageContainer>
                  <Image src={partner.src} />
                </ImageContainer>
              ))}
            </div>
          </CenteredSection>
          <CenteredSection>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              { partners3.map(partner => (
                <ImageContainer>
                  <Image src={partner.src} />
                </ImageContainer>
              ))}
            </div>
          </CenteredSection>
        </div>
      </div>
    )
  }
};

const Image = styled.img`
	display: block;
	height: auto;
	width: 100%;
`;

const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px;
  width: 130px;
  padding-left: 10px;
  padding-right: 10px;
`;

const CenteredSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
`;

const Text = styled.div`
  font-family: 'Karla', sans-serif;
  font-size: 25px;
  color: #505D68;
`;



// WEBPACK FOOTER //
// ./client/redesign/signup/Welcome/index.js